import {FC} from 'react'
import {useIntl} from 'react-intl'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {TablesWidgetKYC} from '../../../_metronic/partials/widgets/_new/tables/TablesWidgetKYC'

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const KYCVerification: FC = () => (
  <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
    <div className='col-lg-12'>
      <TablesWidgetKYC className='card-xxl-stretch mb-5 mb-xl-10' />
    </div>
  </div>
)

const KYCVerificationWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>
        {intl.formatMessage({id: 'PAGE.KYC_VERIFICATION', defaultMessage: 'KYB Verification'})}
      </PageTitle>
      <KYCVerification />
    </>
  )
}

export default KYCVerificationWrapper
